import UserForm from '@/views/App/User/BasicInformation/Form.vue';
import UserBasicInfo from '@/views/App/User/BasicInformation/BsicInformation.vue';
import UserList from '@/views/App/User/List.vue';
import UserQualificationList from '@/views/App/User/Qualification/List.vue';
import FurtherEducationList from '@/views/App/User/FurtherEducation/List.vue';
import StudentWorkingDaysList from '@/views/App/User/StudentWorkingDays/List.vue';
import UserContractList from '@/views/App/User/ExternalUserContract/List.vue';
import {UserRole} from '@/shared/enums/UserRolesEnums';

const routesUser = [
    {
        path: 'list',
        name: 'userList',
        component: UserList
    },
    {
        path: 'form/:id?',
        name: 'userForm',
        component: UserForm
    },
    {
        path: 'basic-info/:id',
        name: 'userBasicInfo',
        component: UserBasicInfo
    },
    // {
    //     path: 'user-profile',
    //     name: 'userProfile',
    //     component: UserProfile
    // },
    {
        path: 'qualification-list/:id',
        name: 'userQualificationList',
        component: UserQualificationList
    },
    {
        path: 'further-education-list/:id',
        name: 'furtherEducationList',
        component: FurtherEducationList
    },
    {
        path: 'student-working-days-list/:id',
        name: 'studentWorkingDaysList',
        component: StudentWorkingDaysList
    },
    {   // BSG only (the tab is shown only for BSG): HR manages and signs contracts of external users
        path: 'contract-list/:id',
        name: 'userContractList',
        component: UserContractList,
        meta: {roles: [UserRole.ADMIN, UserRole.PERSONAL, UserRole.HEAD_OF_HR]},
    },
];

export default routesUser;